export const BLOCKS_TO_REMOVE = [
  'map',
  'icon',
  'input',
  'select',
  'label',
  'radio',
  'checkbox',
  'textarea',
  'button',
  'form',
  'video',
  'column3-7',
  'imageBox',
  'accordion',
];

// Hide buttons from the editor
export const hideButtons =
  (websiteType: string) =>
  ({ items }: any) => {
    const hide = new Set(['showCode', 'clearCanvas']);
    if (websiteType === 'user-website') {
      hide.add('preview');
      hide.add('fullscreen');
    }
    return (items ?? []).filter((it: any) => it && !hide.has(it.id));
  };
